module.exports = __webpack_public_path__ + "static/media/hpv1.a6952e5d.webp";